import React, { FC, Fragment, useEffect } from "react";
import { FontIcon, Image } from "@fluentui/react";
import { ISofProps } from "./SofPage";
import { mergeStyleSets } from "@fluentui/react";
import { NextActionType } from "./NextStateModal";
import { ActivityLog, ProcessFlowStep } from "../../models/ProcessFlowConfig";
import { LineHandling, SofView } from "../../models";
import { toOrdinalString } from "../../services/Helper";
import { useState } from "react";
import ApiSpinner from "../common/ApiSpinner";
import ActionModal from "./ActionModal";
import Moment from "react-moment";
import NextStateModal from "./NextStateModal";
import NominationsStatusPane from "./NominationsStatusPane";
import SofIcon from "../common/Icons";
import TimeStampModal from "./TimeStampModal";
import "moment-timezone";
import { SofProcessor } from "../../services/SofProcessor";

import { pushNotification } from "../../api/pushNotification";
import { useHistory, useParams } from "react-router-dom";
import queryString from "query-string";
import moment from "moment";

interface Props extends ISofProps {
  className: string | undefined;
  lineHandlingNo: string;
  nominationNo: string | undefined;
}

type ActivityItem = {
  status?: number;
  startedOn?: string;
  finishedOn?: string;
  description?: string;
  surveyor?: string;
  order?: number;
  isStartOffline: boolean;
  isEndOffline: boolean;
};

const classes = mergeStyleSets({
  disabledBG: {
    background: "rgba(255, 255, 255, 0.4)",
    position: "fixed",
    bottom: 0,
    right: 0,
    width: "calc(58% - 60px)",
    height: "calc(75vh - 50px)",
    zIndex: 999,
  },
  filler: {
    height: 600,
  },
});

const activeStatus = [0, 1, 2, 5];

const ActivityLogsPage: FC<Props> = (props: Props) => {
  const { sofView, config, selectedState } = props;
  const { activityLogs, lineHandling, nomination } = props;
  const { lineHandlingNo } = useParams() as any;
  //const [lineHandlingNo, setLineHandlingNo] = useState("");
  const [nominationNo, setNominationNo] = useState<string>();
  const [selectedStateId, setSelectedStateId] = useState(0);
  const [steps, setSteps] = useState<ProcessFlowStep[]>([]);
  const [selectedStep, setSelectedStep] = useState<ProcessFlowStep>();
  const [surveyor, setSurveyor] = useState<string>();
  const [showActionModal, setShowActionModal] = useState(false);
  const [showTimeStampModal, setShowTimeStampModal] = useState(false);
  const [newState, setNewState] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [showNewStateModal, setShowNewStateModal] = useState(false);
  const [nextActionType, setNextActionType] = useState(
    NextActionType.NEXT_STATE
  );
  const history = useHistory();

  const renderMessage = (message: string) => (
    <div key="msg" className="no-activity">
      <SofIcon iconname="Exclamation2" iconcolor="var(--primary-500)" />
      <h5
        style={{
          color: "var(--grey-800)",
          fontWeight: 700,
          fontSize: "16px",
          marginTop: "16px",
        }}
      >
        Select Nomination
      </h5>
      <p
        key="no-activity"
        style={{
          fontWeight: 400,
          fontSize: 14,
          color: "var(--grey-400)",
          width: "250px",
          margin: "16px auto 0 auto",
        }}
      >
        {message}
      </p>
    </div>
  );

  const scrollIntoActiveView = () => {
    const divActiveSectionElement = document.getElementById("first-active-row");
    if (divActiveSectionElement !== null) {
      divActiveSectionElement.scrollIntoView({ behavior: "auto" });
    } else {
      const activitiesPane = document.getElementById("activities-pane");
      if (activitiesPane) activitiesPane.scrollTo(0, 0);
    }
  };

  const replaceMergeFields = (str: string, order: number = 1) => {
    if (str.indexOf("{surveyor}") >= 0) {
      if (nomination) return str.replace("{surveyor}", nomination.surveyor);
      else return str.replace("{surveyor}", "surveyor");
    } else if (str.indexOf("{n}") >= 0) {
      return str.replace("{n}", toOrdinalString(order));
    } else if (str.indexOf("{vesseltype}") >= 0) {
      return str.replace(
        "{vesseltype}",
        lineHandling.result ? lineHandling.result.vesselType : "Vessel"
      );
    } else {
      return str;
    }
  };

  const renderRows = () => {
    const isLineHandlingSelected = nomination === undefined;
    const maxGroupIndex2 = 8;

    let buttonRows = [];
    let hasActiveYet = false;
    const activeStatus = [0, 1, 5];
    const filteredActivities =
      activityLogs.result &&
      activityLogs.result
        .sort((a, b) => a.id - b.id)
        .filter(
          (f) =>
            (f.state === selectedState || f.state === "") &&
            (nominationNo === null || nominationNo === f.nominationNo)
        );
    if (filteredActivities && filteredActivities.length > 0) {
      for (let ctr = 0; ctr <= maxGroupIndex2; ctr++) {
        const rowId = `row-${ctr}`;
        let hasElement = false;
        let divGroup = (
          <div
            key={`action-group-${ctr}`}
            id={rowId}
            className="action-button-group ms-Grid-row"
          >
            {steps
              .filter(
                (f) =>
                  f.groupIndex === ctr &&
                  (!f.processFlowStateId ||
                    f.processFlowStateId === selectedStateId)
              )
              .sort((s1, s2) => s1.order - s2.order)
              .map((step) => {
                let items: ActivityItem[] = [];

                if (filteredActivities) {
                  const stepActivityLogs = filteredActivities.filter(
                    (f) =>
                      f.processStepId === step.id &&
                      (nominationNo === null || nominationNo === f.nominationNo)
                  );

                  if (stepActivityLogs.length > 0) {
                    const distinctSurveyors = stepActivityLogs
                      .map((s) => s.surveyor)
                      .filter((s, i, ss) => ss.indexOf(s) === i);

                    const maxRepeationOrder = Math.max.apply(
                      null,
                      stepActivityLogs.map((s) => s.repetitionOrder)
                    );

                    for (var _surveyor of distinctSurveyors) {
                      const sstepActivityLogs = stepActivityLogs.filter(
                        (f) => f.surveyor === _surveyor
                      );
                      const lastActivitylog =
                        sstepActivityLogs[sstepActivityLogs.length - 1];
                      const startActivities = sstepActivityLogs.find(
                        (f) =>
                          f.repetitionOrder === maxRepeationOrder &&
                          f.status === 1
                      );
                      const endActivities = sstepActivityLogs.find(
                        (f) =>
                          f.repetitionOrder === maxRepeationOrder &&
                          f.status === 2
                      );
                      let isStartOffline =
                        startActivities && startActivities.offline;
                      let isEndOffline = endActivities && endActivities.offline;
                      const startedOn =
                        startActivities &&
                        (isStartOffline
                          ? moment
                              .utc(startActivities.logTime)
                              .format("YYYY-MM-DD HH:mm:ss")
                          : startActivities.logTime);
                      const finishedOn =
                        endActivities &&
                        (isEndOffline
                          ? moment
                              .utc(endActivities.logTime)
                              .format("YYYY-MM-DD HH:mm:ss")
                          : endActivities.logTime);
                      const description = lastActivitylog.description;
                      const status = lastActivitylog.status;
                      const order = lastActivitylog.repetitionOrder;

                      items = [
                        ...items,
                        {
                          status,
                          startedOn,
                          finishedOn,
                          description,
                          surveyor: _surveyor,
                          order,
                          isStartOffline,
                          isEndOffline,
                        } as ActivityItem,
                      ];
                    }
                  }
                }

                if (items.length === 0) {
                  items = [{ description: step.name } as ActivityItem];
                }

                return items.map((item, index) => {
                  let itemId = `step-${step.id}`;
                  if (
                    item.status === undefined &&
                    !SofProcessor.checkConditions(
                      step.displayConditions,
                      lineHandling.result,
                      nomination,
                      []
                    )
                  )
                    return <Fragment />;
                  if (
                    !hasActiveYet &&
                    item.status !== undefined &&
                    activeStatus.indexOf(item.status) >= 0
                  ) {
                    itemId = `first-active-row`;
                    hasActiveYet = true;
                  }
                  if (
                    item.status !== 4 &&
                    !(item.status === undefined && step.hide)
                  ) {
                    hasElement = true;
                    return (
                      <Fragment key={`${step.id}-${index}`}>
                        <div id={itemId} className="ms-Grid-col ms-md3 ms-sm4">
                          <div
                            id={`btn-step-${step.id}`}
                            className={`action-button status-${
                              item.status === undefined ? "00" : item.status
                            }`}
                            onClick={() => {
                              if (item.status !== undefined) {
                                setSelectedStep(step);
                                setSurveyor(item.surveyor);
                                if (
                                  (activeStatus.indexOf(item.status) >= 0 &&
                                    !lineHandling.result?.isRejected) ||
                                  (activeStatus.indexOf(item.status) >= 0 &&
                                    lineHandling.result?.isRejected &&
                                    item.description === "Departure")
                                ) {
                                  setShowActionModal(true);
                                  setShowTimeStampModal(false);
                                } else if (item.status === 2) {
                                  setShowActionModal(false);
                                  setShowTimeStampModal(true);
                                } else if (lineHandling.result?.isRejected) {
                                }
                              }
                            }}
                          >
                            <div
                              className={`action-header status-${
                                item.status === undefined ? "00" : item.status
                              }`}
                            >
                              <span className="action-header-title">
                                {item.status === undefined && "Inactive"}
                                {item.status === 0 && "To Do"}
                                {item.status === 1 && "In Progress"}
                                {item.status === 2 && "Done"}
                                {item.status === 3 && "Skipped"}
                                {item.status === 5 && "Paused"}
                              </span>
                              <span className="action-header-icon">
                                {item.status === undefined && (
                                  <SofIcon iconname="InactiveIcon" />
                                )}
                                {item.status === 0 && (
                                  <SofIcon iconname="TodoIcon" />
                                )}
                                {item.status === 1 && (
                                  <SofIcon iconname="InProgressIcon" />
                                )}
                                {item.status === 2 && (
                                  <FontIcon iconName="CheckMark" />
                                )}

                                {item.status === 3 && (
                                  <FontIcon iconName="Cancel" />
                                )}

                                {item.status === 5 && (
                                  <FontIcon iconName="Pause" />
                                )}
                              </span>
                            </div>

                            <span className="action-desc">
                              {item.description &&
                                replaceMergeFields(
                                  item.description,
                                  item.order
                                )}
                            </span>

                            <div className="action-footer">
                              <div style={{ display: "inline-block" }}>
                                {item.startedOn && (
                                  <span
                                    style={
                                      item.isStartOffline
                                        ? { color: "rgb(184, 184, 184)" }
                                        : {}
                                    }
                                  >
                                    <i className="act-time-icon"></i>
                                    <Moment format="HH:mm - M/D/YYYY" local>
                                      {`${item.startedOn} UTC`}
                                    </Moment>
                                  </span>
                                )}

                                {item.startedOn && item.finishedOn && (
                                  <div className="vconnector"></div>
                                )}

                                {item.finishedOn && (
                                  <span
                                    style={
                                      item.isEndOffline
                                        ? { color: "rgb(184, 184, 184)" }
                                        : {}
                                    }
                                  >
                                    <i
                                      className="act-time-icon"
                                      style={{
                                        backgroundColor: "#D32F2F",
                                      }}
                                    ></i>
                                    <Moment
                                      format="HH:mm - M/D/YYYY"
                                      local
                                    >{`${item.finishedOn} UTC`}</Moment>
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    );
                  }
                });
              })}
          </div>
        );

        if (hasElement) buttonRows.push(divGroup);
      }
    }
    if (buttonRows.length === 0) {
      if (isLineHandlingSelected && selectedState === "...") {
        buttonRows.push(
          <div key="nom-status" className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <NominationsStatusPane />
            </div>
          </div>
        );
      } else {
        buttonRows.push(
          renderMessage("No activity to show in the current view..")
        );
      }
    }
    return buttonRows;
  };

  const onStateChange = (
    newState: string,
    _lineHandling: LineHandling,
    updatedActivityLogs: ActivityLog[]
  ) => {
    let nextActionType: NextActionType = NextActionType.NEXT_STATE;
    let msg: string = `${selectedState} operations are done. Proceed to ${newState} to continue.<br />Click "Ok" to proceed to the next stage, or "Cancel" to remain in the current view.`;
    const nominationNo = nomination && nomination.nominationNo;
    const activeActivities = SofProcessor.getCurrentActivityPerStep(
      updatedActivityLogs
    ).filter(
      (f) =>
        f.state === newState &&
        (nomination === undefined ||
          f.nominationNo === nomination.nominationNo) &&
        activeStatus.indexOf(f.status) >= 0
    );

    if (!nominationNo) {
      if (_lineHandling.status === 3) {
        msg = "All operations for this line handling are complete.";
        nextActionType = NextActionType.FINISHED;
      } else {
        if (activeActivities && activeActivities.length > 0) {
          // default values
        } else {
          const hasaActiveNominations = _lineHandling.nominations.filter(
            (f) => f.status < 2
          );
          if (hasaActiveNominations) {
            msg = `${selectedState} operations are done. No current operation for Line Handling. To continue, select a nomination.`;
            nextActionType = NextActionType.SELECT_NOMINATION;
          } else {
            msg = "This Line Handling is done";
            nextActionType = NextActionType.FINISHED;
          }
        }
      }
    } else {
      if (activeActivities && activeActivities.length > 0) {
        // default values
      } else {
        const activeNominations = _lineHandling.nominations.filter(
          (f) => f.status < 2
        );
        if (activeNominations.length > 0) {
          msg = `This nomination is done. Please select a different nomination to continue.`;
          nextActionType = NextActionType.SELECT_NOMINATION;
        } else {
          msg =
            "All nominations are done. Go back to Line Handling view to proceed.";
          nextActionType = NextActionType.BACK_TO_LINE_HANDLING;
        }
      }
    }

    setNewState(newState);
    setModalMessage(msg);
    setNextActionType(nextActionType);
    setShowNewStateModal(true);
  };

  const refreshData = async (hasError: boolean) => {
    if (hasError) {
      const { search } = history.location;
      const q = queryString.parse(search.toLowerCase());
      //const linehandlingno = q.linehandling as string;
      const nominationno = q.nomination as string | undefined;

      props.getActivityLogs(lineHandlingNo.toUpperCase(), () => {
        props.getLineHandling(
          lineHandlingNo,
          nominationno,
          false,
          false,
          () => {
            let previousPage = `/marine/${lineHandlingNo}/sof`;
            if (nominationno) {
              previousPage += `?nomination=${nominationno}`;
            }
            if (history.location.search !== previousPage) {
              history.push(previousPage);
            }
          }
        );
      });
    }

    setSelectedStep(undefined);
  };

  useEffect(() => {
    if (config && selectedState) {
      if (activityLogs.result) {
        var stepList: ProcessFlowStep[] = [];

        const activityLogGrpIndex = activityLogs.result.filter(
          (a) => a.groupIndex != null
        );
        config.steps.forEach(function (step, index) {
          var activityLog = activityLogGrpIndex.find(
            (a) => a.processStepId === step.id
          );
          var groupIndex = step.groupIndex;
          if (
            activityLog &&
            activityLog.groupIndex &&
            !isNaN(activityLog.groupIndex)
          )
            groupIndex = Number(activityLog.groupIndex);

          const stepItem = {
            id: step.id,
            processFlowStateId: step.processFlowStateId,
            processFlowConfigId: step.processFlowConfigId,
            name: step.name,
            order: step.order,
            groupIndex: groupIndex,
            startAs: step.startAs,
            conditions: step.conditions,
            hide: step.hide,
            displayConditions: step.displayConditions,
            actions: step.actions,
          } as ProcessFlowStep;

          stepList.push(stepItem);
        });

        setSteps(stepList);
      } else {
        setSteps(config.steps);
      }

      const state = config.states.find((f) => f.name === selectedState);
      state && setSelectedStateId(state.id);
    }

    // lineHandling.result &&
    //   setLineHandlingNo(lineHandling.result.lineHandlingNo);
    setNominationNo(nomination ? nomination.nominationNo : undefined);
  }, [config, activityLogs, selectedState, props.nomination]);

  useEffect(() => scrollIntoActiveView());

  useEffect(() => {
    if (selectedStep === undefined) {
      setShowTimeStampModal(false);
      setShowActionModal(false);
    } else {
      scrollIntoActiveView();
    }
  }, [selectedStep]);

  useEffect(() => {
    pushNotification.connection.off("ActionExecuted");
    pushNotification.connection.off("NominationAdded");

    pushNotification.connection.on("ActionExecuted", (message) => {
      var result = message as string[];
      let cnt = 0;

      if (
        result[0].toUpperCase() === lineHandlingNo.toUpperCase() &&
        result[1] !== props.correlationId &&
        cnt === 0
      ) {
        cnt += 1;
        refreshData(true);
      }
    });

    pushNotification.connection.on("NominationAdded", (message) => {
      let cnt = 0;

      if (message.toUpperCase() === lineHandlingNo.toUpperCase() && cnt === 0) {
        cnt += 1;
        refreshData(true);
      }
    });

    return () => {
      pushNotification.connection.off("ActionExecuted");
      pushNotification.connection.off("NominationAdded");
    };
  }, [lineHandlingNo]);

  return (
    <>
      {selectedStep && showActionModal && props.isMarineEditActivityAllowed && (
        <ActionModal
          {...props}
          correlationId={props.correlationId}
          step={selectedStep}
          surveyor={surveyor}
          onCancel={(hasError: boolean) => refreshData(hasError)}
          onStateChange={onStateChange}
        />
      )}
      {selectedStep && showTimeStampModal && (
        <TimeStampModal
          {...props}
          step={selectedStep}
          surveyor={surveyor}
          readonly={!props.isMarineEditTimestampAllowed}
          onClose={() => {
            setSelectedStep(undefined);
            refreshData(true);
          }}
        />
      )}
      <div id="activities-pane" className="activities-pane">
        {sofView === SofView.NominationEdit && (
          <div className={classes.disabledBG} />
        )}
        <div className="ms-Grid" dir="ltr">
          {activityLogs.isLoading && <ApiSpinner />}
          {!activityLogs.isLoading &&
            sofView === SofView.None &&
            renderMessage(
              "Activities will appear after selecting a nomination."
            )}
          {!activityLogs.isLoading && sofView !== SofView.None && renderRows()}
        </div>
        {sofView !== SofView.None && <div className={classes.filler} />}
      </div>
      {selectedState && (
        <NextStateModal
          currentState={selectedState}
          nextState={newState}
          message={modalMessage}
          display={showNewStateModal}
          actionType={nextActionType}
          onClick={() => {
            setShowNewStateModal(false);
            switch (nextActionType) {
              case NextActionType.NEXT_STATE:
                props.setSelectedState(newState);
                break;
              case NextActionType.SELECT_NOMINATION:
                props.setSelectedState(newState);
                break;
              case NextActionType.BACK_TO_LINE_HANDLING:
                if (props.lineHandling.result) {
                  props.setSelectedState(
                    props.lineHandling.result.currentState
                  );
                  history.push(`/marine/${props.lineHandlingNo}/sof`);
                }
                break;
              case NextActionType.FINISHED:
                break;
            }
          }}
          onCancel={() => setShowNewStateModal(false)}
        />
      )}
    </>
  );
};
export default ActivityLogsPage;
